function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "72 x 72 copy");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-15.9%",
  y: "-22.7%",
  width: "131.8%",
  height: "163.6%",
  filterUnits: "objectBoundingBox",
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.154939147   0 0 0 0 0.810480442   0 0 0 0 0.680896698  0 0 0 1 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons",
  transform: "translate(-941.000000, -2447.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Running-clean-up-rules-after-scaling-for-digital-mediums",
  transform: "translate(79.000000, 1395.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(9.000000, 451.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "72-x-72-copy",
  transform: "translate(853.000000, 601.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "bg",
  fill: "#2EDAB8",
  x: 0,
  y: 0,
  width: 72,
  height: 72,
  rx: 36
}), /*#__PURE__*/React.createElement("g", {
  id: "icon",
  filter: "url(#filter-1)",
  transform: "translate(14.000000, 27.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "left-top",
  points: "0 0 5.5 8 38.5 8 44 0"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "left-bottom",
  points: "5.5 14 11 22 33 22 38.5 14"
})))))));

var SvgAutopilot = function SvgAutopilot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAutopilot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/autopilot.74e67b68.svg";
export { ForwardRef as ReactComponent };